<template>
    <div id="daylight-app" :class="{'embed': (this.$router.mode == 'hash')}">
        <b-navbar fixed
                  toggleable="lg"
                  type="dark"
                  class="bg-darkgreen"
                  v-if="this.$router.mode == 'history'"
        ><b-container >
                <b-navbar-brand to="/">

                    <svg id="brett_martin_logo" xmlns="http://www.w3.org/2000/svg" data-name="brett_martin_logo" viewBox="0 0 193 163" width="193" height="163">
                        <title>Brett Martin Logo</title>
                        <g fill-rule="evenodd" clip-rule="evenodd">
                            <path fill="#eee" d="M0 0L192.76 0L192.76 163L0 163L0 0Z" />
                            <path fill="#004E43" d="M2.83 3.11L189.92 3.11L189.92 159.64L2.83 159.64L2.83 3.11ZM7 155.46L185.73 155.46L185.73 7.27L7 7.27L7 155.46ZM184.96 154.69L7.76 154.69L7.76 8.04L184.97 8.04L184.96 154.69Z" />
                            <path fill="#eee" d="M149.67 122.87C149.67 124.43 150.82 124.93 152.77 125.31L146.28 125.31C147.62 124.82 148.8 124.05 148.69 122.6L148.69 107.16C148.42 106.39 147.24 104.75 144.83 104.36L149.87 104.36L163.26 120.74L163.26 106.09C163.26 105.13 162.19 104.64 160.24 104.25L166.73 104.25C165.39 104.75 164.02 103.95 164.02 106.2L164.02 125.5L149.67 107.76L149.67 122.87ZM30.95 122.87C31.06 124.93 31.34 124.93 33.28 125.31L27.18 125.31C28.52 124.82 29.78 124.92 29.7 122.98L30.57 105.81C30.38 104.64 28.44 104.17 28.44 104.17L33.09 104.36L39.77 120.54L46.94 104.17L52.28 104.17C50.64 104.94 49.96 104.75 49.76 105.9L50.64 122.87C50.83 124.93 51.52 124.93 53.46 125.31L45.41 125.31C46.75 124.82 48.01 124.93 47.93 122.98L47.16 106.01L38.89 125.12L31.72 106.96L30.95 122.87ZM88.75 122.6C88.75 124.73 89.33 124.82 91.27 125.2L83.6 125.2C84.97 124.73 86.23 124.82 86.15 122.87L86.15 105.81C85.85 105.02 83.8 104.36 83.8 104.36L92.83 104.25C97.38 104.25 99.24 107.76 99.24 109.48C99.24 112.22 96.42 114.44 93.9 114.63L100.2 122C101.07 123.17 101.46 123.56 103.51 125.2L98.85 125.2C95.54 121.72 93.79 118.52 90.31 114.93C89.93 114.93 89.14 114.82 88.86 115.12C88.86 117.26 88.75 120.27 88.75 122.6ZM88.75 114.06C88.75 114.06 96.42 114.93 96.42 109.89C96.42 106.01 91.96 105.32 88.75 105.62L88.75 114.06ZM68.38 93.3C68.38 95.44 68.99 95.52 70.9 95.9L63.26 95.9C64.6 95.44 65.86 95.52 65.78 93.57L65.78 76.52C65.48 75.75 63.45 75.07 63.45 75.07L72.46 74.96C77.03 74.96 78.87 78.46 78.87 80.21C78.87 82.93 76.05 85.14 73.53 85.33L79.83 92.73C80.7 93.88 81.08 94.26 83.14 95.9L78.48 95.9C75.17 92.73 73.42 88.84 69.94 85.64C69.56 85.64 68.76 85.53 68.49 85.83C68.49 87.96 68.38 90.97 68.38 93.3ZM76.05 80.6C76.05 76.71 71.59 76.03 68.38 76.33L68.38 84.76C68.38 84.76 76.05 85.64 76.05 80.6ZM133.27 122.87L133.27 106.5C133.27 104.94 132.78 105.02 130.75 104.36L138.31 104.36C136.56 104.64 135.9 104.64 135.9 106.5L135.9 122.87C135.9 124.24 136.28 124.73 138.5 125.31L130.64 125.31C132.4 125.01 133.16 124.24 133.27 122.87ZM57.43 125.39C56.66 125.39 58.8 125.12 59.37 123.37L66.16 104.36L68.49 104.36L75.97 123.67C75.97 123.67 76.54 124.82 77.8 125.31L70.9 125.31C71.97 124.82 72.65 124.33 72.46 123.56L70.43 117.64L62.96 117.64C62.08 120.46 59.27 124.13 63.26 125.39L57.43 125.39ZM70.14 116.77L66.74 106.88L63.54 116.77L70.14 116.77ZM145.68 96.01L138.8 96.01C140.64 95.33 140.94 95.44 140.94 93.99L140.94 76.41L136.37 76.41C135.71 76.41 134.92 75.94 133.96 78.08L133.96 74.3C133.96 73.7 133.85 75.15 135.79 75.15L149.48 75.15C150.55 75.15 150.78 74.63 150.82 74.31L150.82 78.27C150.63 76.22 150.06 76.41 149.07 76.41L143.57 76.41L143.57 93.99C143.57 94.56 143.35 95.25 145.68 96.01ZM150.82 74.31L150.82 74.08C150.82 74.08 150.84 74.18 150.82 74.31ZM118.35 125.31L111.45 125.31C113.29 124.63 113.59 124.73 113.59 123.26L113.59 105.7L109.02 105.7C108.36 105.7 107.56 105.24 106.61 107.35L106.61 103.57C106.61 103 106.5 104.45 108.44 104.45L122.13 104.45C123.2 104.45 123.43 103.92 123.47 103.61L123.47 107.57C123.28 105.51 122.7 105.71 121.75 105.71L116.22 105.71L116.22 123.26L116.22 123.26C116.22 123.86 116.02 124.52 118.35 125.31ZM123.47 103.61L123.47 103.38C123.47 103.38 123.49 103.47 123.47 103.61ZM121.75 96.01L114.85 96.01C116.68 95.33 116.98 95.44 116.98 93.99L116.98 76.41L112.41 76.41C111.75 76.41 110.96 75.94 110 78.08L110 74.3C110 73.7 109.89 75.15 111.83 75.15L125.52 75.15C126.6 75.15 126.83 74.62 126.87 74.31L126.87 78.27C126.67 76.22 126.1 76.41 125.11 76.41L119.61 76.41L119.61 93.99L119.61 93.99C119.61 94.56 119.39 95.25 121.75 96.01ZM126.87 74.31L126.87 74.08C126.87 74.08 126.88 74.18 126.87 74.31ZM93.02 84.27L98.86 84.08C100.31 84.08 100.31 82.05 100.31 82.43L100.31 86.4C100.31 86.7 100.2 84.95 98.94 84.95L93.13 85.06L93.13 92.04C93.13 93.58 92.91 95.06 94.97 95.06C96.12 95.06 99.43 94.95 100.01 94.95C101.83 94.95 102.72 94.08 102.88 93.27C102.83 94.04 102.72 96.01 102.72 96.01L88.48 96.01C90.7 94.95 90.5 95.14 90.5 93.69L90.5 77.78C90.5 75.83 89.44 75.83 87.99 75.07L102.25 75.07C102.44 75.07 102.33 75.75 102.33 77.78C102.33 77.78 101.84 76.22 99.92 76.22L96.04 76.22C94.28 76.22 93.02 76.22 93.02 78.16L93.02 84.27ZM102.88 93.27C102.9 93.03 102.91 92.91 102.91 93C102.91 93.09 102.9 93.18 102.88 93.27ZM42.59 77.78C42.59 74.77 38.51 75.07 40.15 75.07L49.57 75.07C52.58 75.07 56.85 75.94 56.85 79.53C56.85 82.13 54.53 83.61 52.09 84.18C55.1 84.38 58.31 86.81 58.31 89.99C58.31 94.45 53.65 96.01 50.15 96.01C48.89 96.01 40.15 95.9 40.15 95.9C41.33 95.9 42.59 95.33 42.59 93.3L42.59 77.78ZM48.81 83.8C51.13 83.8 53.84 82.54 53.84 79.72C53.84 76.33 51.22 75.94 48.2 75.94C46.1 75.94 45.11 76.03 45.11 77.7L45.11 83.8L48.81 83.8ZM45.11 91.55C45.11 95.71 46.18 95.25 49.27 95.25C52.39 95.25 55.21 93.58 55.21 90.1C55.21 87.47 54.72 84.95 50.45 84.95L45.11 84.95L45.11 91.55Z" />
                            <path fill="#e72529" d="M52.67 46.65C86.34 53.44 106.49 12.42 132.59 26C102.52 19.29 84.21 59.93 52.67 46.65Z" />
                            <path fill="#e72529" d="M58.99 52.56C92.64 59.35 112.82 18.34 138.88 31.92C108.82 25.21 90.5 65.84 58.99 52.56L58.99 52.56Z" />
                            <path fill="#e72529" d="M65.78 58.67C99.43 65.46 119.61 24.44 145.68 38.02C115.61 31.31 97.29 71.97 65.78 58.67L65.78 58.67Z" />
                        </g>
                    </svg>
                    <!--<span>Daylight Systems</span>-->
                </b-navbar-brand>

                <b-navbar-toggle target="nav_collapse" />

                <b-collapse is-nav id="nav_collapse" class="justify-content-end">
                    <b-navbar-nav>
                        <b-nav-item to="/">Home</b-nav-item>
                        <b-nav-item to="/products/mardome">Products</b-nav-item>
                        <b-nav-item @click="installer()"
                                    :style="{'display': installBtn}"
                        >Install App</b-nav-item>
                        <b-nav-item to="/contact">Contacts</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </b-container>
        </b-navbar>

        <div>
            <transition name="fast-fade" mode="out-in" @after-leave="afterLeave">
                <router-view/>
            </transition>
        </div>

        <section id="footer" v-if="this.$router.mode == 'history'">
            <social-links class="mb-3"></social-links>
            <p>
                <strong><a href="http://www.brettmartin.com/en-gb/daylight-systems.aspx" class="alink" target="_blank">Brett Martin Daylight Systems</a></strong><br>
                Sandford Close, Aldermans Green Industrial Estate,<br>
                Coventry, West Midlands, CV2 2QU
            </p>
            <p>
                Tel: +44 (0) 24 7660 2022 | Fax: +44 (0)24 7660 2745<br>
                Email: daylight@brettmartin.com
            </p>

            <p class="pt-3"><a class="alink" @click.prevent="flushCachesRefresh()">Having trouble?, click here to refresh content</a></p>
        </section>
    </div>
</template>
<script>
    export default {
        components: {
            'SocialLinks': () => import(/* webpackChunkName: "social-links" */ './components/SocialLinks.vue'),
        },
        data() {
            return {
                installBtn: 'none',
                installer: undefined,
                pageLoaded: false,
            }
        },
        created() {
            let installPrompt

            window.addEventListener("beforeinstallprompt", e => {
                // Prevent Chrome 67 and earlier from automatically showing the prompt
                e.preventDefault()
                // Stash the event so it an be triggered later.
                installPrompt = e
                // Update UI notify the user they can add to home screen.
                this.installBtn = 'block'
            })

            this.installer = () => {
                // hide the install button
                this.installBtn = 'none'
                // Show the prompt
                installPrompt.prompt();
                // Wait for the user to respond to the prompt
                installPrompt.userChoice.then(function () {
                    installPrompt = null
                })
            }
        },
        methods: {
            afterLeave () {
                this.$root.$emit('triggerScroll')
            },
            flushCachesRefresh() {
                "use strict";
                caches.keys().then(function (cs) {
                    return cs.forEach(function (c) {
                        return caches.delete(c);
                    });
                });
                window.location.reload(true);
                window.location.href = '/';
            }
        }
    }
</script>
<style lang="scss">
    #daylight-app {
        .navbar-brand {
            position: relative;
            padding-top: 0;
            padding-bottom: 0;
            margin-right: 0;

            span {
                font-size: 14px;
                position: absolute;
                bottom: 0px;
                left: 5px;
                text-transform: uppercase;
                font-weight: 100;
                opacity: 0.5;
                letter-spacing: 0.1em;
                @media (max-width: 991px) {
                    font-size: 8.5px;
                    bottom: 1px;
                    left: 0px;
                }
            }
        }
        #brett_martin_logo {
            width: auto;
            height: 60px;
            opacity: 0.9;

            @media (max-width: 991px) {
                height: 42px;
                margin-left: 0px;
            }
        }
        section#footer {
            text-align:center;
            padding: 40px 20px;
            font-size:0.6rem;
            color: #eee;
            background-color: #003B3D;
            strong {
                font-size: 0.7rem;
            }
            a.alink {
                cursor: pointer;
                color: white;
                &:hover {
                    color: yellow;
                    text-decoration: none;
                }
            }
        }
        a.btn-primary {
            color: #fff;
            background-color: #066d56;
            border-color: #066d5682;
            &:hover {
                background-color: #067962;
                border-color: #06796282;
            }
        }
        .bg-darkgreen {
            background-color: #003B3D;
        }
        .navbar img.daylight-logo {
            max-height: 40px;
            @media (min-width: 992px) {
                max-height: 60px;
            }
        }
        button.btn-action, a.btn-action {
            background-color: $btn-action;
            border: 1px solid rgba(255, 255, 255, 0.1);
            &:hover {
                border: 1px solid rgba(255, 255, 255, 0.1);
                background-color: $btn-action-hover;
            }
            font-size: 12px;
            font-weight: 200;
        }
        button.btn-cancel, a.btn-cancel {
            background-color: #ccc;
            border-color: #ddd;
            font-size: 12px;
            font-weight: 200;
        }
        .dark {
            background-color: $dark-bg;
            color: #eee;
            font-weight: 200;
            .btn {
                background-color: $btn-action;
                border: 1px solid rgba(0, 0, 0, 0.1);
                &:hover {
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    background-color: $btn-action-hover;
                }
            }
            .btn-cancel {
                &:hover {
                    background-color: lighten($primary-color, 4%);
                }
            }
        }
    }
</style>
